
import { useState } from "react";
import { Dialog } from "@/components/ui/dialog";
import { ContactCard } from "../ContactCard";
import { ContactPhotoUpload } from "../ContactPhotoUpload";

interface Contact {
  id: string;
  full_name: string | null;
  title: string | null;
  work_email: string | null;
  linkedin_profile?: string | null;
  phone_number?: string | null;
  key_contact: boolean;
  avatar_url?: string | null;
}

interface ContactListProps {
  contacts: Contact[];
  fundId?: string;
}

export function ContactList({ contacts, fundId }: ContactListProps) {
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
  const [localContacts, setLocalContacts] = useState<Contact[]>(contacts);
  const keyContacts = localContacts.filter(contact => contact.key_contact);

  const handlePhotoUpdate = (updatedContact: Contact) => {
    setLocalContacts(prevContacts => 
      prevContacts.map(contact => 
        contact.id === updatedContact.id ? updatedContact : contact
      )
    );
    setSelectedContact(null);
  };

  // If there are no contacts, show empty state
  if ((contacts?.length || 0) === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No contacts available.
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {(keyContacts?.length || 0) > 0 && (
        <div className="grid gap-4 sm:grid-cols-2">
          {keyContacts.map(contact => (
            <ContactCard
              key={contact.id}
              contact={contact}
              onPhotoClick={() => setSelectedContact(contact)}
            />
          ))}
        </div>
      )}

      <Dialog open={!!selectedContact} onOpenChange={() => setSelectedContact(null)}>
        {selectedContact && fundId && (
          <ContactPhotoUpload
            contact={selectedContact}
            fundId={fundId}
            onComplete={handlePhotoUpdate}
          />
        )}
      </Dialog>
    </div>
  );
}
